import axios, { AxiosRequestConfig } from 'axios';
import { GetterTree, MutationTree, ActionTree } from 'vuex';
import { RootState, cardRemittancesState } from '@/util/interface';
import { STATUS_ERROR } from '@/constant';
import { Request } from '@/util/types';


const config: AxiosRequestConfig = {
  baseURL: `${process.env.VUE_APP_API_BASE_URL}transfer/`,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
};

const request = ({
  url,
  method,
  data,
  params,
}: Request) => {
  config.url = url;
  config.method = method;
  config.data = data;
  config.params = params;
  return axios(config);
};

const state: cardRemittancesState = {
  remittancesToCard: {},
  remittancesToCardErrors:{},
  remittancesToCardStatus: {},
  remittancesToCardConfirm: {}
};
const getters: GetterTree<cardRemittancesState, RootState> = {
  remittancesToCard: (state) => state.remittancesToCard,
  remittancesToCardErrors: (state) => state.remittancesToCardErrors,
  remittancesToCardStatus: (state) => state.remittancesToCardStatus,
  remittancesToCardConfirm: (state) => state.remittancesToCardConfirm,
};
const actions: ActionTree<cardRemittancesState, RootState> = {
  async prevalidationRemittancesToCard ({ commit }, data) {
    try {
      const res = await request({
        url: 'sim2cardV2/info',
        method: 'post',
        data
      });
      res.data.status === STATUS_ERROR
        ? commit('setRemittancesToCardErrors', res.data)
        : commit('setRemittancesToCardErrors', {});

      commit('setRemittancesToCard',
        {
          ...res.data,
          ...data
        });
      return res.data;
    } catch (err) {
      if (err?.response?.data) {
        commit('setRemittancesToCardErrors', err.response.data.errors);
        return err.response;
      }
    }
  },
  async initializationCardRemittances ({ commit }, data) {
    try {
      const res = await request({
        url: 'sim2cardV2/init',
        method: 'post',
        data
      });
      return res.data;
    } catch (err) {
      if (err?.response?.data) {
        commit('setRemittancesToCardErrors', err.response.data.errors);
        return err.response;
      }
    }
  },

  async confirmRemittancesToCard ({ commit }, data) {
    commit('setLoading', true, { root: true });
    return await request(
      { url: 'sim2cardV2/confirm',
        method: 'post' ,
        data })
      .then((res) => {
        const  { response } = res.data;

        if (response.status === STATUS_ERROR) {
          commit('setRemittancesToCardErrors', response);
        }

        commit('setRemittancesToCardConfirm', response);
        return response;
      }).catch((err) => {
        if (err?.response?.data) {
          const  { errors } = err.response.data;

          commit('setRemittancesToCardErrors', errors);
          return errors;
        }
      }).finally(() => {
        commit('setLoading', false, { root: true });
      });
  },

  async getStatusOfRemittancesToCard ({ commit }, data) {
    return await request({ url: 'status',
      method: 'post' ,
      data })
      .then((res) => {
        commit('setRemittancesToCardStatus', res.data);
      });
  },


  // eslint-disable-next-line no-unused-vars
  resendOtp ({ commit }, data){
    return request({ url: 'otp/resend',
      method: 'post' ,
      data });
  },
  
};
const mutations: MutationTree<cardRemittancesState> = {
  setRemittancesToCard (state, data) {
    state.remittancesToCard = { ...data };
  },
  setRemittancesToCardErrors (state, data) {
    state.remittancesToCardErrors = { ...data };
  },
  setRemittancesToCardStatus(state, payload) {
    state.remittancesToCardStatus = payload;
  },
  setRemittancesToCardConfirm(state, payload) {
    state.remittancesToCardConfirm = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
